import { PropsWithClassname } from '@/app/types';

export const PrintIcon = ({ className }: PropsWithClassname) => {
  return (
    <svg
      className={className}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_18571_21796" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.234375" y="0.949219" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18571_21796)">
        <path
          d="M8.23438 21.9492C7.68437 21.9492 7.21354 21.7534 6.82188 21.3617C6.43021 20.9701 6.23438 20.4992 6.23438 19.9492V17.9492H4.23438C3.68438 17.9492 3.21354 17.7534 2.82188 17.3617C2.43021 16.9701 2.23438 16.4992 2.23438 15.9492V11.9492C2.23438 11.0992 2.52604 10.3867 3.10938 9.81172C3.69271 9.23672 4.40104 8.94922 5.23438 8.94922H19.2344C20.0844 8.94922 20.7969 9.23672 21.3719 9.81172C21.9469 10.3867 22.2344 11.0992 22.2344 11.9492V15.9492C22.2344 16.4992 22.0385 16.9701 21.6469 17.3617C21.2552 17.7534 20.7844 17.9492 20.2344 17.9492H18.2344V19.9492C18.2344 20.4992 18.0385 20.9701 17.6469 21.3617C17.2552 21.7534 16.7844 21.9492 16.2344 21.9492H8.23438ZM18.2344 7.94922H6.23438V5.94922C6.23438 5.39922 6.43021 4.92839 6.82188 4.53672C7.21354 4.14505 7.68437 3.94922 8.23438 3.94922H16.2344C16.7844 3.94922 17.2552 4.14505 17.6469 4.53672C18.0385 4.92839 18.2344 5.39922 18.2344 5.94922V7.94922ZM18.2344 13.4492C18.5177 13.4492 18.7552 13.3534 18.9469 13.1617C19.1385 12.9701 19.2344 12.7326 19.2344 12.4492C19.2344 12.1659 19.1385 11.9284 18.9469 11.7367C18.7552 11.5451 18.5177 11.4492 18.2344 11.4492C17.951 11.4492 17.7135 11.5451 17.5219 11.7367C17.3302 11.9284 17.2344 12.1659 17.2344 12.4492C17.2344 12.7326 17.3302 12.9701 17.5219 13.1617C17.7135 13.3534 17.951 13.4492 18.2344 13.4492ZM8.23438 19.9492H16.2344V15.9492H8.23438V19.9492Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
